import { memo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { WarehouseContactCardProps } from "./types";
import { transformRoute, useTranslate } from "helpers";
import { Routes as ContactRoutes } from "ui/modules/contacts/navigation";
import { NoResults } from "ui/components/NoResults";
import { TableSearch } from "ui/components/Table/TableSearch";
import { WAREHOUSE_CONTACT_SEARCH_COLUMNS } from "./consts";

const WarehouseContactCard: React.FC<WarehouseContactCardProps> = (props) => {
  const { fleetWarehouseDetail } = props;

  const { t } = useTranslate();
  const navigate = useNavigate();

  const contacts = fleetWarehouseDetail.contacts ?? [];

  const handleRowClick = useCallback(
    (id: string) => {
      navigate(transformRoute(ContactRoutes.ContactDetailPageRouter, { id }));
    },
    [navigate]
  );

  return (
    <div className="space-y-3 mt-1">
      <div className="m-[-1px]">
        {contacts.length === 0 ? (
          <NoResults message={t("admin.fleet.warehouse.detail.contact.noresults")} />
        ) : (
          <TableSearch
            columns={WAREHOUSE_CONTACT_SEARCH_COLUMNS(t)}
            data={contacts}
            selectableRows={false}
            disablePagination={true}
            isLoading={false}
            onRowClick={handleRowClick}
          />
        )}
      </div>
    </div>
  );
};

export default memo(WarehouseContactCard);
